import React from "react";
import CustomTooltip from "../../../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "../../../../components/ui/use-toast";

const PolicyActionButton = ({
  id,
  setEdit,
  setPolicyId,
  toggleShowAddEditPolicy,
  toggleShowDelete,
  is_used,
  policy_file,
}) => {
  const handleDownload = async (export_path) => {
    try {
      if (export_path) {
        var a = document.createElement("a");
        a.href = export_path;
        var file = export_path.split("/");
        a.setAttribute("download", file[file.length - 1] || "file.pdf");
        a.setAttribute("target", "_blank");
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    } catch (e) {
      const errors = e.response?.data?.errors;
      toast({
        variant: "destructive",
        description: errors,
        duration: 3000,
      });
    }
  };

  return (
    <>
      <span className="flex items-center gap-2 justify-center">
        {policy_file && (
          <>
            <CustomTooltip message={"Download"}>
              <span>
                <FontAwesomeIcon
                  icon={faDownload}
                  size="1x"
                  onClick={() => {
                    handleDownload(policy_file);
                  }}
                />
              </span>
            </CustomTooltip>
            <span>/</span>
          </>
        )}
        <CustomTooltip message={"Edit"}>
          <span>
            <FontAwesomeIcon
              icon={faEdit}
              size="1x"
              onClick={() => {
                setEdit(true);
                toggleShowAddEditPolicy();
                setPolicyId(id);
              }}
            />
          </span>
        </CustomTooltip>
        {!is_used && (
          <>
            <span>/</span>
            <CustomTooltip message={"Delete"}>
              <span>
                <FontAwesomeIcon
                  icon={faTrash}
                  size="1x"
                  onClick={() => {
                    setPolicyId(id);
                    toggleShowDelete();
                  }}
                />
              </span>
            </CustomTooltip>
          </>
        )}
      </span>
    </>
  );
};

export default PolicyActionButton;
